<template>
    <div style="line-height:0; position:relative;" :class="{'upload-cropper-container':true, 'cross-inside':crossInside }">
        <croppa
            v-model="model"
            ref="croppa"
            :width="width"
            :height="height"
            :canvas-color="'default'"
            :placeholder="'Carica l\'immagine principale'"
            :placeholder-font-size="fontSize"
            :placeholder-color="'default'"
            :accept="'image/*'"
            :file-size-limit="0"
            :quality="quality"
            :zoom-speed="3"
            :disabled="false"
            :disable-drag-and-drop="disabled"
            :disable-click-to-choose="false"
            :disable-drag-to-move="disabled"
            :disable-scroll-to-zoom="disabled"
            :disable-rotation="disabled"
            :prevent-white-space="true"
            :reverse-scroll-to-zoom="false"
            :show-remove-button="true"
            :remove-button-color="'#921a2d'"
            :remove-button-size="25"
            initial-size="cover"
            :initial-image="url | relativeUrl"
            @new-image-drawn="handleChange"
            @image-remove="remove"
            @move="handleChange"
            @zoom="handleChange"
            @file-choose="removeDisabled"
            ></croppa>
    </div>
</template>
<script>
    export default {
        name: "form-element-upload-cropper",
        data() {
            return {
                disabled: true
            }
        },
        props: {
            imagewidth: { type:Number, default:750 },
            imageheight: { type: Number, default:500 },
            quality: { type:Number, default: 2 },
            value: {},
            error: { type: String, default: null },
            meta: { type: Boolean, default: true },
            crossInside: { type: Boolean, default: false },
            fontSize: { type: Number, default: 0},
            url:{type:String},
            aspect: {type: Object, default: function(){ return {}; }}
        },
        mounted(){
            let c = this.$refs.croppa.$el;
            c.getElementsByTagName("canvas")[0].style.width="100%";
            c.getElementsByTagName("canvas")[0].style.height="auto";
        },
        computed:{
            width(){
                return this.imagewidth;
            },
            height(){
                return this.imageheight;
            },
            model:{
                get(){return this.value;},
                set(v){this.$emit('input',v);}
            }
        },
        methods: {
            remove(){
                this.$emit("update:url", null);
                this.handleChange();
            },
            removeDisabled(){
                this.disabled = false; 
            },
            handleChange(){     
                this.$emit("change");
            }
        },
        filters: {
            relativeUrl: function (value) {
                if (!value) return '';
                return value.replace("https://www.teatro.it", "").replace("http://www.teatro.it", "");
            }
        }
    }
</script>
<style>
    .upload-cropper-container.cross-inside svg{
        top: 15px !important;
        right: 10px !important;
    }
</style>